import { styled, css, keyframes } from 'styled-components';
import { VisuallyHiddenStyles } from '../visually-hidden/visually-hidden.styles';
import { InputMessageContainer } from '../input-message/input-message.styles';

export type CheckboxWrapperProps = {
  $marginBottom?: string;
};
export const CheckboxWrapper = styled.div<CheckboxWrapperProps>`
  display: flex;
  align-items: stretch;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: ${({ $marginBottom }) => $marginBottom || 0};
  &:not(:last-of-type) {
    margin-bottom: 1.2rem;
  }

  ${InputMessageContainer} {
    margin-top: 0px;
    margin-left: 25px;
  }
`;

const jiggle = keyframes`
  0% { transform: translateX(0); }
  15% { transform: translateX(-3px); }
  30% { transform: translateX(3px); }
  45% { transform: translateX(-3px); }
  60% { transform: translateX(3px); }
  75% { transform: translateX(-3px); }
  100% { transform: translateX(0); }
`;

interface CheckboxContainerProps {
  $isError?: boolean;
  $disabled?: boolean;
}
export const CheckboxContent = styled.span``;

export const CheckboxContainer = styled.label<CheckboxContainerProps>`
  position: relative;
  padding-top: 2px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  input {
    ${VisuallyHiddenStyles}
  }

  ${CheckboxContent} {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 16px;
    width: 16px;
    background-color: transparent;
    border: 1px solid ${({ theme }) => theme.colors.checkbox.borderColorDefault};
    transition: all 0.3s ease;
    border-radius: 2px;
    transition-property: border-color, box-shadow, background-color;
    transition-duration: 0.2s;

    ${({ theme, $isError }) =>
      $isError
        ? theme.colors.baseColors.red80
        : theme.colors.baseColors.grey100};

    ${({ theme, $isError }) =>
      $isError &&
      css`
        border-color: ${theme.colors.baseColors.red100};
      `}

    ${({ $isError }) =>
      $isError &&
      css`
        animation: ${jiggle} 0.4s ease;
      `}
  }

  ${CheckboxContent}:active {
    outline: none;
    border-color: ${({ theme }) => theme.colors.checkbox.borderColorFocus};
    box-shadow: 0 0 0 3px #89caff;
  }

  input ~ ${CheckboxContent} svg {
    display: none;
  }

  input:focus ~ ${CheckboxContent} {
    outline: none;
    border-color: ${({ theme }) => theme.colors.checkbox.borderColorFocus};
    box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.checkbox.shadowColor};
  }

  input:checked ~ ${CheckboxContent} {
    background-color: ${({ theme }) =>
      theme.colors.checkbox.backgroundColorChecked};
    border-color: ${({ theme }) => theme.colors.checkbox.borderColorChecked};
  }

  input:checked ~ ${CheckboxContent} svg {
    display: block;
  }

  input:disabled ~ ${CheckboxContent} {
    background-color: ${({ theme }) => theme.colors.baseColors.grey50};
    border-color: ${({ theme }) => theme.colors.baseColors.grey50};
  }

  ${({ $disabled }) =>
    $disabled
      ? css`
          cursor: default;
          pointer-events: none;
        `
      : undefined}
`;
